<template>
  <!-- basic modal -->
  <!-- gig create location modal -->
  <b-modal
    id="create-areas-modal"
    :title="isEditing ? $t('areas_management.titles.edit') : $t('areas_management.titles.create')"
    size="lg"
    :no-close-on-backdrop="true"
    cancel-variant="outline-secondary"
    :cancel-title="$t('back')"
    :ok-title="isEditing ? $t('areas_management.save_changes') : $t('create')"
    scrollable
    @hidden="resetModal"
    @ok="handleCreateLocation"
    @show="onModalOpen"
  >
    <validation-observer ref="rules">
      <b-form
        ref="form"
        @submit.stop.prevent="handleSubmit"
      >
        <b-col cols="12">
          <b-row>
            <!-- section info -->
            <b-col cols="12">
              <b-form-group
                :label="$t('areas_management.form_items.area_name')"
                label-for="section"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t('areas_management.form_items.area_name')"
                  rules="required"
                >
                  <b-form-input
                    id="areas-name"
                    v-model="form.name"
                    :state="errors.length > 0 ? false:null"
                    :placeholder="$t('areas_management.place_holders.location_name')"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>

        <b-col cols="12">
          <b-row>
            <!-- section info -->
            <b-col
              v-if="user.role !== 'customer'"
              cols="12"
            >
              <b-form-group
                :label="$t('areas_management.form_items.client_email')"
                label-for="email"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t('areas_management.form_items.client_email')"
                  rules="required"
                >
                  <v-select
                    v-model="form.emails"
                    multiple
                    taggable
                    :no-drop="true"
                    style="text-transform: lowercase"
                  />
                  <small
                    class="text-danger"
                  >
                    {{ errors[0] ? $t('areas_management.form_items.client_email_warning') : errors[0] }}
                  </small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
        <b-col
          v-if="user.role !== 'customer'"
          cols="12"
        >
          <b-row>
            <b-col
              cols="12"
            >
              <b-form-checkbox
                v-model="isCheckConfirmEmails"
                class="mb-1"
                @change="changeConfirmEmailsSelected"
              >
                {{ $t('areas_management.form_items.same_email_checkbox') }}
              </b-form-checkbox>
            </b-col>
            <b-col
              v-if="!isCheckConfirmEmails"
              cols="12"
            >
              <b-form-group
                :label="$t('areas_management.form_items.confirmation_emails')"
                label-for="email"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t('areas_management.form_items.confirmation_emails')"
                  rules="required"
                >
                  <v-select
                    v-model="form.confirmation_emails"
                    multiple
                    taggable
                    :no-drop="true"
                    style="text-transform: lowercase"
                  />
                  <small
                    class="text-danger"
                  >
                    {{ errors[0] ? $t('areas_management.form_items.confirm_email_warning') : errors[0] }}
                  </small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
        <b-col>
          <hr>
        </b-col>
        <!-- Contract Section -->
        <b-col cols="12">
          <b-row>
            <b-col cols="6">
              <b-form-group
                v-if="user.role === 'admin' || appConfig.type === 'ow-admin'"
                :label="appConfig.type === 'hw-admin' ? $t('areas_management.form_items.contract') : $t('area_contract')"
                label-for="contract"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t('areas_management.form_items.contract')"
                  rules="required"
                >
                  <v-select
                    v-model="form.contract"
                    label="label"
                    :placeholder="appConfig.type === 'hw-admin' ? $t('areas_management.place_holders.contract') : $t('pick_contract')"
                    :options="contractOptions"
                    :clearable="false"
                    style="text-transform: capitalize"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group
                :label="$t('areas_management.form_items.category')"
                label-for="category"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t('areas_management.form_items.category')"
                  rules="required"
                >
                  <v-select
                    v-model="form.category"
                    label="label"
                    :placeholder="$t('areas_management.place_holders.category')"
                    :options="appConfig.type === 'hw-admin' ? categoryOptionsHoiwa : categoryOptionsOiwa"
                    :clearable="false"
                    style="text-transform: capitalize"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
        <b-col>
          <hr>
        </b-col>

        <!-- Address Section -->
        <b-col cols="12">
          <b-row>
            <!-- street address -->
            <b-col cols="6">
              <b-form-group
                :label="$t('areas_management.form_items.street_address')"
                label-for="street-address"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t('areas_management.form_items.street_address')"
                  rules="required"
                >
                  <b-form-input
                    id="street-address"
                    v-model="form.location.address.streetAddress"
                    :state="errors.length > 0 ? false:null"
                    placeholder=""
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- city -->
            <b-col cols="6">
              <b-form-group
                :label="$t('areas_management.form_items.city')"
                label-for="city"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t('areas_management.form_items.city')"
                  rules="required"
                >
                  <b-form-input
                    id="city"
                    v-model="form.location.address.city"
                    :state="errors.length > 0 ? false:null"
                    placeholder=""
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- post code -->
            <b-col cols="6">
              <b-form-group
                :label="$t('areas_management.form_items.postcode')"
                label-for="postcode"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t('areas_management.form_items.postcode')"
                  rules="required"
                >
                  <b-form-input
                    id="postcode"
                    v-model="form.location.address.postcode"
                    :state="errors.length > 0 ? false:null"
                    type="number"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- state -->
            <b-col cols="6">
              <b-form-group
                :label="$t('areas_management.form_items.state')"
                label-for="state"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t('areas_management.form_items.state')"
                  rules="required"
                >
                  <v-select
                    v-model="form.location.address.state"
                    :state="errors.length > 0 ? false:null"
                    label="State"
                    :options="$i18n.locale === 'fi' ? stateOptions : germanStateOptions"
                    :clearable="false"
                    style="text-transform: capitalize"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
        <br>
        <b-col cols="12">
          <b-row>
            <b-col cols="3">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="outline-primary"
                class="mr-1"
                block
                :disabled="!form.location.address.streetAddress || fetchingLatLon"
                @click="setLatLon"
              >
                <b-spinner
                  v-show="fetchingLatLon"
                  small
                />
                <span
                  v-show="!fetchingLatLon"
                >
                  {{ $t('areas_management.buttons.gps') }}
                </span>
              </b-button>
            </b-col>
            <b-col cols="3">
              <validation-provider
                #default="{ errors }"
                :name="$t('areas_management.place_holders.latitude')"
                rules="required"
              >
                <b-form-input
                  id="lat"
                  v-model="form.location.gps.lat"
                  :placeholder="$t('areas_management.place_holders.latitude')"
                  type="number"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <b-col cols="3">
              <validation-provider
                #default="{ errors }"
                :name="$t('areas_management.place_holders.longitude')"
                rules="required"
              >
                <b-form-input
                  id="lon"
                  v-model="form.location.gps.lon"
                  :placeholder="$t('areas_management.place_holders.longitude')"
                  type="number"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
          </b-row>
        </b-col>
        <b-col>
          <b-row>
            <!-- location details -->
            <b-col cols="12" style="margin-top: 20px;">
              <b-form-group
                :label="$t('areas_management.form_items.location_details')"
                label-for="location-details"
              >
                <b-form-textarea
                  id="textarea-no-resize"
                  v-model="form.location.locationDetails"
                  :placeholder="$t('entrance_placeholder')"
                  rows="3"
                  no-resize
                />
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>

        <b-col>
          <hr>
        </b-col>

        <b-col cols="12">
          <b-row>
            <b-col cols="12">
              <b-form-group
                :label="$t('areas_management.form_items.contact_info')"
                label-for="contact_1"
              />
            </b-col>
            <b-col cols="6">
              <b-form-group>
                <b-form-input
                  id="contact_1"
                  v-model="form.location.contact[0]"
                  :placeholder="$t('phone_placeholder')"
                />
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group>
                <b-form-input
                  id="contact_2"
                  v-model="form.location.contact[1]"
                />
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group>
                <b-form-input
                  id="contact_3"
                  v-model="form.location.contact[2]"
                  :placeholder="$t('email_placeholder')"
                />
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group>
                <b-form-input
                  id="contact_4"
                  v-model="form.location.contact[3]"
                  placeholder=""
                />
              </b-form-group>
            </b-col>
            <!-- abscence info -->
            <b-col cols="12">
              <b-form-group
                label-for="abscence"
                :label="$t('areas_management.form_items.absence_info')"
              >
                <b-form-textarea
                  id="abscence"
                  v-model="form.location.abscenceInfo"
                  placeholder=""
                  rows="3"
                  no-resize
                />
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
        <b-col>
          <hr>
        </b-col>

        <b-col v-if="appConfig.type === 'hw-admin'">
          <hr>
        </b-col>
            
        <b-col v-if="appConfig.type === 'hw-admin'" cols="6">
          <b-form-group
            label="Kohteen vaatimat asiakirjat"
            label-for="documentRequests"
          >
            <v-select
              v-model="form.requirements"
              taggable
              multiple
              :no-drop="true"
            />
          </b-form-group>
        </b-col>
      </b-form>
    </validation-observer>
  </b-modal>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BModal, BRow, BCol, BForm, BFormGroup, BFormInput, BFormTextarea,
  BFormCheckbox, BButton, BSpinner,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import { required } from '@validations'
import i18n from '@hw-core/libs/i18n'
import ToastificationContent from '@hw-ui/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BModal,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BFormCheckbox,
    BButton,
    BSpinner,
    vSelect,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  props: {
    editArea: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      required,
      customeAlert: 'Please enter required infomation',
      contractOptions: [],
      isEditing: false,
      fetchingLatLon: false,
      form: {
        contract: null,
        name: '',
        emails: [],
        location: {
          address: {},
          contact: [],
          abscenceInfo: '',
          sectionInfo: '',
          gps: {
            lat: null,
            lon: null,
          },
          locationDetails: '',
        },
        confirmation_emails: [],
        category: null,
        requirements: [],
      },
      stateOptions: [
      'Ahvenanmaa',
      'Etelä-Karjala',
      'Etelä-Pohjanmaa',
      'Etelä-Savo',
      'Kainuu',
      'Kanta-Häme',
      'Keski-Pohjanmaa',
      'Keski-Suomi',
      'Kymenlaakso',
      'Lappi',
      'Pirkanmaa',
      'Pohjanmaa',
      'Pohjois-Karjala',
      'Pohjois-Pohjanmaa',
      'Pohjois-Savo',
      'Päijät-Häme',
      'Satakunta',
      'Uusimaa',
      'Varsinais-Suomi',
      ],
      germanStateOptions: [
      'Baden-Württemberg',
      'Bayern',
      'Berlin',
      'Brandenburg',
      'Bremen',
      'Hamburg',
      'Hessen',
      'Mecklenburg-Vorpommern',
      'Niedersachsen',
      'Nordrhein-Westfalen',
      'Rheinland-Pfalz',
      'das Saarland',
      'Sachsen',
      'Sachsen-Anhalt',
      'Schleswig-Holstein',
      'Thüringen',
      ],
      processer: {},
      categoryOptionsHoiwa: [
        { label: i18n.t('home_care'), value: 'kotihoito' },
        { label: i18n.t('nursing_home'), value: 'hoitokoti' },
        { label: i18n.t('reception'), value: 'vastaanotto' },
        { label: i18n.t('service_home'), value: 'palvelutalo' },
        { label: i18n.t('hospital'), value: 'sairaala' },
        { label: i18n.t('health_centre'), value: 'terveysasema' },
        { label: i18n.t('vaccination'), value: 'rokotus' },
        { label: i18n.t('sampling'), value: 'näytteenotto' },
      ],
      categoryOptionsOiwa: [
        { label: 'Korjaamo', value: 'korjaamo' }
      ],
      isCheckConfirmEmails: true,
    }
  },
  computed: {
    user() {
      return this.$store.state.appAuth.authUser ? this.$store.state.appAuth.authUser : {}
    },
    appConfig() {
      return this.$store.state.app.appConfig || {}
    },
  },
  beforeCreate() {
    this.$store.dispatch('appAuth/getCurrentUser')
      .then(res => {
        const user = JSON.parse(JSON.stringify(res))
        this.processer = {
          firstName: user.firstName,
          lastName: user.lastName,
        }
      })
  },
  methods: {
    resetModal() {
      this.contractOptions = []
      this.isEditing = false
      this.form = {
        name: '',
        emails: [],
        contract: null,
        location: {
          address: {},
          contact: [],
          abscenceInfo: '',
          sectionInfo: '',
          gps: {
            lat: null,
            lon: null,
          },
          locationDetails: '',
        },
        confirmation_emails: [],
        category: null,
        requirements: [],
      }
      this.isCheckConfirmEmails = true
      this.$emit('modal-close')
    },
    checkFormValidity() {
      const valid = this.$refs.form.checkValidity()
      return valid
    },
    handleSubmit() {
      this.$refs.rules.validate().then(success => {
        if (success) {
          this.form.location.sectionInfo = this.form.name
          if (this.isCheckConfirmEmails) {
            this.form.confirmation_emails = []
          }
          this.form.location.address.state = this.form.location.address.state.toLowerCase()
          if (this.form.location.abscenceInfo === '') {
            this.form.location.abscenceInfo = 'Akuutit poissaolot ilmoitetaan klo 6.45, arkipyhisin ja vkl klo 7:00'
          }

          this.$emit('create-area', {
            area: {
              ...this.form,
              category: this.form.category.value === undefined
                ? this.form.category
                : this.form.category.value
            },
            action: this.isEditing ? 'edit' : 'create',
          })
          this.$bvModal.hide('create-areas-modal')
        }
      })
    },
    setLatLon() {
      this.fetchingLatLon = true
      const address = `${this.form.location.address.streetAddress} ${this.form.location.address.city}`
      this.$store.dispatch('appAreas/fetchLocationLatLon', { address })
        .then(response => {
          const gps = response.data.result
          this.form.location.gps.lat = gps.latitude
          this.form.location.gps.lon = gps.longitude
          this.fetchingLatLon = false
        })
        .catch(() => {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: this.$t('error'),
              text: this.$t('areas_management.toast_message.could_not_get_location'),
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
          this.fetchingLatLon = false
        })
    },
    handleCreateLocation(event) {
      event.preventDefault()
      this.$refs.rules.validate().then(success => {
        if (success) {
          if (this.form.name && (this.user.role === 'customer' ? true : this.form.emails)
          && this.form.contract && this.form.location.address.streetAddress
          && this.form.location.address.city && this.form.location.address.postcode
          && this.form.location.address.state && this.form.location.gps.lat
          && this.form.location.gps.lon) {
            this.handleSubmit()
          }
        }
      })
    },
    onModalOpen() {
      if (this.editArea) {
        this.isEditing = true
        this.form = { ...this.editArea, contract: null }
        if (this.editArea.confirmation_emails && this.editArea.confirmation_emails.length > 0) {
          this.isCheckConfirmEmails = false
        }
        // Fix: Make sure state is lowervase, otherwise won't show up to users
        this.form.location.address.state = this.form.location.address.state.toLowerCase()
      }
      this.$emit('modal-open', {
        callback: ({ contracts }) => {
          this.contractOptions = contracts
          this.form.contract = contracts.find(contract => this.isEditing && contract.value.id === this.editArea.contract)
        },
      })
    },
    changeConfirmEmailsSelected(value) {
      if (value) this.form.confirmation_emails = []
    },
  },
}
</script>
